<div class="tile-board-editor">
  <!-- Header Section -->
  <div class="board-editor-header">
    <h2>{{ mode === 'create' ? 'Create Tile Board' : 'Edit Tile Board' }}</h2>
    
    <div class="board-details-inline">
      <mat-form-field appearance="outline" class="board-input">
        <mat-label>Board Name</mat-label>
        <input matInput [(ngModel)]="board.userBoardName" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="board-input">
        <mat-label>Board Description</mat-label>
        <input matInput [(ngModel)]="board.userBoardDescription" />
      </mat-form-field>
    </div>
  </div>

  <!-- Action Bar -->
  <div class="editor-action-bar">
    <div class="editor-actions-left">
      <button mat-raised-button color="primary" (click)="addComponent()">
        <mat-icon>add</mat-icon>
        Add Tile
      </button>
      
      <mat-form-field appearance="fill">
        <mat-label>Filter Bar</mat-label>
        <mat-select [(ngModel)]="board.filterBarId" (selectionChange)="onFilterBarChange($event.value)">
          <mat-option [value]="''">None</mat-option>
          <mat-option *ngFor="let filterBar of filterBars" [value]="filterBar.filterBarId">
            {{ filterBar.filterBarName }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="editor-actions-right">
      <button mat-raised-button color="primary" (click)="save()">Save Board</button>
      <button mat-button (click)="cancel()">Cancel</button>
    </div>
  </div>

  <!-- Filter Bar Preview -->
  <bhub-filter-bar 
    *ngIf="selectedFilterBar"
    [filterBar]="selectedFilterBar"
    [isEditing]="false">
  </bhub-filter-bar>

  <!-- Gridster Container -->
  <div class="gridster-container">
    <gridster class="gridster-class" [options]="gridsterOptions">
      <gridster-item class="gridster-item" *ngFor="let item of board.itemList" [item]="item">
        <ng-template #tileTemplate></ng-template>
      </gridster-item>
    </gridster>
  </div>
</div>